import { Box, Divider, Paper, Toolbar, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { ChartsLocalizationProvider } from "@mui/x-charts/ChartsLocalizationProvider";
import { svSELocaleText } from "@mui/x-charts/locales";
import { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BusClaimApiService from "../../adapters/xhr/BusClaimApiService";
import { MyButton } from "../../components/my-button/MyButton";
import { MyDatePicker } from "../../components/my-date-picker/MyDatePicker";
import MyContext from "../../contexts/MyContext";

export const BusStatisticsPage = () => {
  const { t, i18n } = useTranslation();
  //claims
  const [automationCurrentYearClaims, setAutomationCurrentYearClaims] = useState();
  const [manualCurrentYearClaims, setManualCurrentYearClaims] = useState();
  const [ownCarCurrentYearClaims, setOwnCarCurrentYearClaims] = useState();
  const [otherTransportCurrentYearClaims, setOtherTransportCurrentYearClaims] = useState();
  const [periodCurrentYearClaims, setPeriodCurrentYearClaims] = useState();
  const [singleCurrentYearClaims, setSingleCurrentYearClaims] = useState();
  const [resplusCurrentYearClaims, setResplusCurrentYearClaims] = useState();
  const [currentYearClaims, setCurrentYearClaims] = useState();
  const [lastYearClaims, setLastYearClaims] = useState();
  const [dailyClaims, setDailyClaims] = useState();
  // reimbursement
  const [currentYearReimbursement, setCurrentYearReimbursement] = useState();
  const [lastYearReimbursement, setLastYearReimbursement] = useState();
  const [ownCarCurrentYearReimbursement, setOwnCarCurrentYearReimbursement] = useState();
  const [otherTransportCurrentYearReimbursement, setOtherTransportCurrentYearReimbursement] = useState();
  const [periodCurrentYearReimbursement, setPeriodCurrentYearReimbursement] = useState();
  const [singleCurrentYearReimbursement, setSingleCurrentYearReimbursement] = useState();
  const [resplusCurrentYearReimbursement, setResplusCurrentYearReimbursement] = useState();
  // top
  const [mostCommonTrainNumbers, setMostCommonTrainNumbers] = useState();
  const [trainNumbersWithMostReimbursement, setTrainNumbersWithMostReimbursement] = useState();
  const [mostCommonRoutes, setMostCommonRoutes] = useState();
  const [routesWithMostReimbursement, setRoutesWithMostReimbursement] = useState();

  const [date, setDate] = useState(new Date().toString());
  const [year, setYear] = useState();
  const [month, setMonth] = useState();
  const [day, setDay] = useState();

  const months = ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"];

  const days = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"];

  const myContext = useContext(MyContext);

  const fetchMonthlyClaims = useCallback(async () => {
    const promises = [];

    promises.push(BusClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), automated: true }));
    promises.push(BusClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), automated: false }));
    promises.push(BusClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), receiptType: "OwnCar" }));
    promises.push(BusClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), receiptType: "Other" }));
    promises.push(BusClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear() }));
    promises.push(BusClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear() - 1 }));
    promises.push(BusClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), ticketType: "Period" }));
    promises.push(BusClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), ticketType: "Single" }));
    promises.push(BusClaimApiService.getMonthlyClaims({ year: new Date(date).getFullYear(), ticketType: "Resplus" }));

    const [automationCurrentYearClaimsResponse, manualCurrentYearClaimsResponse, ownCarCurrentYearClaimsResponse, otherTransportCurrentYearClaimsResponse, currentYearClaimsResponse, lastYearClaimsResponse, periodCurrentYearResponse, singleCurrentYearResponse, resplusCurrentYearResponse] = await Promise.all(promises);
    if (automationCurrentYearClaimsResponse?.isSuccess && manualCurrentYearClaimsResponse?.isSuccess && ownCarCurrentYearClaimsResponse?.isSuccess && otherTransportCurrentYearClaimsResponse?.isSuccess && currentYearClaimsResponse?.isSuccess && lastYearClaimsResponse?.isSuccess && periodCurrentYearResponse?.isSuccess && singleCurrentYearResponse?.isSuccess && resplusCurrentYearResponse?.isSuccess) {
      setAutomationCurrentYearClaims(automationCurrentYearClaimsResponse.data);
      setManualCurrentYearClaims(manualCurrentYearClaimsResponse.data);
      setOwnCarCurrentYearClaims(ownCarCurrentYearClaimsResponse.data);
      setOtherTransportCurrentYearClaims(otherTransportCurrentYearClaimsResponse.data);
      setCurrentYearClaims(currentYearClaimsResponse.data);
      setLastYearClaims(lastYearClaimsResponse.data);
      setPeriodCurrentYearClaims(periodCurrentYearResponse.data);
      setSingleCurrentYearClaims(singleCurrentYearResponse.data);
      setResplusCurrentYearClaims(resplusCurrentYearResponse.data);
    }
  }, [date]);

  const fetchMonthlyReimbursement = useCallback(async () => {
    const promises = [];

    promises.push(BusClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear(), receiptType: "OwnCar" }));
    promises.push(BusClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear(), receiptType: "Other" }));
    promises.push(BusClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear() }));
    promises.push(BusClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear() - 1 }));
    promises.push(BusClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear(), ticketType: "Period" }));
    promises.push(BusClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear(), ticketType: "Single" }));
    promises.push(BusClaimApiService.getMonthlyReimbursement({ year: new Date(date).getFullYear(), ticketType: "Resplus" }));

    const [ownCarCurrentYearReimbursementResponse, otherTransportCurrentYearReimbursementResponse, currentYearReimbursementResponse, lastYearReimbursementResponse, periodCurrentYearReimbursementResponse, singleCurrentYearReimbursementResponse, resplusCurrentYearReimbursementResponse] = await Promise.all(promises);
    if (ownCarCurrentYearReimbursementResponse?.isSuccess && otherTransportCurrentYearReimbursementResponse?.isSuccess && currentYearReimbursementResponse?.isSuccess && lastYearReimbursementResponse?.isSuccess && periodCurrentYearReimbursementResponse?.isSuccess && singleCurrentYearReimbursementResponse?.isSuccess && resplusCurrentYearReimbursementResponse?.isSuccess) {
      setOwnCarCurrentYearReimbursement(ownCarCurrentYearReimbursementResponse.data);
      setOtherTransportCurrentYearReimbursement(otherTransportCurrentYearReimbursementResponse.data);
      setCurrentYearReimbursement(currentYearReimbursementResponse.data);
      setLastYearReimbursement(lastYearReimbursementResponse.data);
      setPeriodCurrentYearReimbursement(periodCurrentYearReimbursementResponse.data);
      setSingleCurrentYearReimbursement(singleCurrentYearReimbursementResponse.data);
      setResplusCurrentYearReimbursement(resplusCurrentYearReimbursementResponse.data);
    }
  }, [date]);

  const fetchDailyClaims = useCallback(async () => {
    const promises = [];

    promises.push(BusClaimApiService.getDailyClaims({ year: new Date(date).getFullYear(), month: new Date(date).getMonth() + 1 }));

    const [dailyClaimsResponse] = await Promise.all(promises);

    if (dailyClaimsResponse?.isSuccess) {
      setDailyClaims(dailyClaimsResponse.data);
    }
  }, [date]);

  const fetchMostCommonTrainNumbers = useCallback(async () => {
    const promises = [];

    promises.push(BusClaimApiService.getMostCommonTrainNumbers({ year: new Date(date).getFullYear(), month: new Date(date).getMonth() + 1, day: new Date(date).getDate() }));

    const [mostCommonTrainNumbersResponse] = await Promise.all(promises);

    if (mostCommonTrainNumbersResponse?.isSuccess) {
      setMostCommonTrainNumbers(mostCommonTrainNumbersResponse.data);
    }
  }, [date]);

  const fetchTrainNumbersWithMostReimbursement = useCallback(async () => {
    const promises = [];

    promises.push(BusClaimApiService.getMostCommonTrainNumbers({ mostReimbursement: true, year: new Date(date).getFullYear(), month: new Date(date).getMonth() + 1, day: new Date(date).getDate() }));

    const [response] = await Promise.all(promises);

    if (response?.isSuccess) {
      setTrainNumbersWithMostReimbursement(response.data);
    }
  }, [date]);

  const fetchMostCommonRoutes = useCallback(async () => {
    const promises = [];

    promises.push(BusClaimApiService.getMostCommonRoutes({ year: new Date(date).getFullYear(), month: new Date(date).getMonth() + 1, day: new Date(date).getDate() }));

    const [mostCommonRoutesResponse] = await Promise.all(promises);

    if (mostCommonRoutesResponse?.isSuccess) {
      setMostCommonRoutes(mostCommonRoutesResponse.data);
    }
  }, [date]);

  const fetchRoutesWithMostReimbursement = useCallback(async () => {
    const promises = [];

    promises.push(BusClaimApiService.getMostCommonRoutes({ mostReimbursement: true, year: new Date(date).getFullYear(), month: new Date(date).getMonth() + 1, day: new Date(date).getDate() }));

    const [response] = await Promise.all(promises);

    if (response?.isSuccess) {
      setRoutesWithMostReimbursement(response.data);
    }
  }, [date]);

  useEffect(() => {
    fetchRoutesWithMostReimbursement();
  }, [date, fetchRoutesWithMostReimbursement]);

  useEffect(() => {
    fetchMostCommonRoutes();
  }, [date, fetchMostCommonRoutes]);

  // useEffect(() => {
  //   fetchTrainNumbersWithMostReimbursement();
  // }, [date, fetchTrainNumbersWithMostReimbursement]);

  // useEffect(() => {
  //   fetchMostCommonTrainNumbers();
  // }, [date, fetchMostCommonTrainNumbers]);

  useEffect(() => {
    fetchMonthlyClaims();
  }, [date, fetchMonthlyClaims]);

  useEffect(() => {
    fetchMonthlyReimbursement();
  }, [date, fetchMonthlyReimbursement]);

  useEffect(() => {
    fetchDailyClaims();
  }, [date, fetchDailyClaims]);

  const exportExcel = async () => {
    var response = await BusClaimApiService.getStatisticsInExcel({ year: new Date(date).getFullYear(), month: new Date(date).getMonth() + 1, day: new Date(date).getDate() });
    // Create a URL for the Blob and trigger download
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Charts.xlsx"); // Set the desired file name for download
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url); // Clean up the object URL
  };

  const currentMonth = () => {
    const now = new Date(date);
    return `${now.getFullYear()} ${months[now.getMonth()]}`;
  };

  const currentDay = () => {
    const now = new Date(date);
    return `${now.getFullYear()} ${months[now.getMonth()]} ${now.getDate()}`;
  };

  return (
    <ChartsLocalizationProvider localeText={svSELocaleText}>
      <Paper>
        <Box sx={{ display: "flex" }}>
          <MyDatePicker size="small" onAccept={(date) => setDate(date.toString())} value={date} label={t("date")} style={{ width: "12rem", margin: "1rem 0 1rem 1rem" }} />
          <MyButton text={t("export_to_excel")} color="primary" onClick={async (e) => await exportExcel()} style={{ width: "15rem", margin: "1rem 5rem 1rem 1rem" }} />
        </Box>
        <Divider />
        <Toolbar>
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("number_of_claims_per_month")}
          </Typography>
        </Toolbar>
        {currentYearClaims && lastYearClaims && (
          <BarChart
            height={300}
            dataset={months.map((month, index) => ({ current: currentYearClaims[index], last: lastYearClaims[index], month }))}
            series={[
              { dataKey: "current", label: new Date(date).getFullYear().toString(), valueFormatter: (value) => `${value}` },
              { dataKey: "last", label: (new Date(date).getFullYear() - 1).toString(), valueFormatter: (value) => `${value}` },
            ]}
            xAxis={[{ dataKey: "month" }]}
          />
        )}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("number_of_claims_per_day")}
          </Typography>
        </Toolbar>
        {dailyClaims && (
          <BarChart
            xAxis={[{ data: days, label: currentMonth() }]}
            //
            series={[{ data: dailyClaims, valueFormatter: (value) => `${value}` }]}
            height={300}
          />
        )}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("number_of_claims_per_cost")}
          </Typography>
        </Toolbar>
        {ownCarCurrentYearClaims && otherTransportCurrentYearClaims && (
          <BarChart
            height={300}
            dataset={months.map((month, index) => ({ ownCar: ownCarCurrentYearClaims[index], otherTransport: otherTransportCurrentYearClaims[index], month }))}
            series={[
              { dataKey: "ownCar", label: t("own_car"), valueFormatter: (value) => `${value}` },
              { dataKey: "otherTransport", label: t("other_transport"), valueFormatter: (value) => `${value}` },
            ]}
            xAxis={[{ dataKey: "month", label: new Date(date).getFullYear().toString() }]}
          />
        )}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("number_of_claims_per_ticket_type")}
          </Typography>
        </Toolbar>
        {periodCurrentYearClaims && singleCurrentYearClaims && resplusCurrentYearClaims && (
          <BarChart
            height={300}
            dataset={months.map((month, index) => ({ period: periodCurrentYearClaims[index], single: singleCurrentYearClaims[index], resplus: resplusCurrentYearClaims[index], month }))}
            series={[
              { dataKey: "period", label: t("period"), valueFormatter: (value) => `${value}` },
              { dataKey: "single", label: t("single"), valueFormatter: (value) => `${value}` },
              { dataKey: "resplus", label: t("Ej kategoriserade"), valueFormatter: (value) => `${value}` },
            ]}
            xAxis={[{ dataKey: "month", label: new Date(date).getFullYear().toString() }]}
          />
        )}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("number_of_claims_that_has_gone_for_automation_vs_manual_handling")}
          </Typography>
        </Toolbar>
        {automationCurrentYearClaims && manualCurrentYearClaims && (
          <BarChart
            height={300}
            dataset={months.map((month, index) => ({ automation: automationCurrentYearClaims[index], manual: manualCurrentYearClaims[index], month }))}
            series={[
              { dataKey: "automation", label: t("automation"), valueFormatter: (value) => `${value}` },
              { dataKey: "manual", label: t("manual"), valueFormatter: (value) => `${value}` },
            ]}
            xAxis={[{ dataKey: "month", label: new Date(date).getFullYear().toString() }]}
          />
        )}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("paid_reimbursement_per_month")}
          </Typography>
        </Toolbar>
        {currentYearReimbursement && lastYearReimbursement && (
          <BarChart
            height={300}
            dataset={months.map((month, index) => ({ current: currentYearReimbursement[index], last: lastYearReimbursement[index], month }))}
            series={[
              { dataKey: "current", label: new Date().getFullYear().toString(), valueFormatter: (value) => `${value}` },
              { dataKey: "last", label: (new Date().getFullYear() - 1).toString(), valueFormatter: (value) => `${value}` },
            ]}
            xAxis={[{ dataKey: "month", label: new Date(date).getFullYear().toString() }]}
            // barLabel="value"
          />
        )}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("paid_reimbursement_per_cost")}
          </Typography>
        </Toolbar>
        {ownCarCurrentYearReimbursement && otherTransportCurrentYearReimbursement && (
          <BarChart
            height={300}
            dataset={months.map((month, index) => ({ ownCar: ownCarCurrentYearReimbursement[index], otherTransport: otherTransportCurrentYearReimbursement[index], month }))}
            series={[
              { dataKey: "ownCar", label: t("own_car"), valueFormatter: (value) => `${value}` },
              { dataKey: "otherTransport", label: t("other_transport"), valueFormatter: (value) => `${value}` },
            ]}
            xAxis={[{ dataKey: "month", label: new Date(date).getFullYear().toString() }]}
            // barLabel="value"
          />
        )}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("paid_reimbursement_per_ticket_type")}
          </Typography>
        </Toolbar>
        {periodCurrentYearReimbursement && singleCurrentYearReimbursement && resplusCurrentYearReimbursement && (
          <BarChart
            height={300}
            dataset={months.map((month, index) => ({ period: periodCurrentYearReimbursement[index], single: singleCurrentYearReimbursement[index], resplus: resplusCurrentYearReimbursement[index], month }))}
            series={[
              { dataKey: "period", label: t("period"), valueFormatter: (value) => `${value}` },
              { dataKey: "single", label: t("single"), valueFormatter: (value) => `${value}` },
              { dataKey: "resplus", label: t("Ej kategoriserade"), valueFormatter: (value) => `${value}` },
            ]}
            xAxis={[{ dataKey: "month", label: new Date(date).getFullYear().toString() }]}
            // barLabel="value"
          />
        )}
        {/* common routes/train numbers */}
        {/* <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("top_20_most_common_train_numbers")}
          </Typography>
        </Toolbar>
        {mostCommonTrainNumbers && <BarChart xAxis={[{ label: currentDay(), data: mostCommonTrainNumbers.map((item) => item.trainNumber), categoryGapRatio: 0.9 }]} series={[{ data: mostCommonTrainNumbers.map((item) => item.count), valueFormatter: (value) => `${value}` }]} height={300} />}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("top_20_train_numbers_with_most_reimbursement")}
          </Typography>
        </Toolbar> */}
        {/* {trainNumbersWithMostReimbursement && <BarChart xAxis={[{ label: currentDay(), data: trainNumbersWithMostReimbursement.map((item) => item.trainNumber), categoryGapRatio: 0.9 }]} series={[{ data: trainNumbersWithMostReimbursement.map((item) => item.reimbursementSEK), valueFormatter: (value) => `${value}` }]} height={300} />} */}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("top_20_most_common_routes")}
          </Typography>
        </Toolbar>
        {mostCommonRoutes && <BarChart layout="horizontal" xAxis={[{ label: currentDay(), tickMinStep: 1 }]} yAxis={[{ width: 200, data: mostCommonRoutes.map((item) => `${item.departureStation} - ${item.arrivalStation}`), categoryGapRatio: 0.9 }]} series={[{ data: mostCommonRoutes.map((item) => item.count), valueFormatter: (value) => `${value}` }]} height={350} />}
        <Toolbar className="margin top-2">
          <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
            {t("top_20_routes_with_most_reimbursement")}
          </Typography>
        </Toolbar>
        {routesWithMostReimbursement && <BarChart layout="horizontal" xAxis={[{ label: currentDay() }]} yAxis={[{ width: 200, data: routesWithMostReimbursement.map((item) => `${item.departureStation} - ${item.arrivalStation}`), categoryGapRatio: 0.9 }]} series={[{ data: routesWithMostReimbursement.map((item) => item.reimbursementSEK), valueFormatter: (value) => `${value}` }]} height={350} />}
        <br />
        <br />
        <br />
        <br />
      </Paper>
    </ChartsLocalizationProvider>
  );
};
